var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg100Clock(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_542_123975)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.31579 5.00002C1.31579 2.96527 2.96527 1.31579 5 1.31579C7.03473 1.31579 8.68421 2.96527 8.68421 5.00002C8.68421 7.03476 7.03473 8.68424 5 8.68424C2.96527 8.68424 1.31579 7.03476 1.31579 5.00002ZM5 0.625C2.58375 0.625 0.625 2.58376 0.625 5.00002C0.625 7.41627 2.58375 9.37503 5 9.37503C7.41625 9.37503 9.375 7.41627 9.375 5.00002C9.375 2.58376 7.41625 0.625 5 0.625ZM5.34537 2.31363C5.34537 2.12287 5.19073 1.96823 4.99997 1.96823C4.80922 1.96823 4.65458 2.12287 4.65458 2.31363V5.00004C4.65458 5.1908 4.80922 5.34544 4.99997 5.34544H7.68638C7.87713 5.34544 8.03177 5.1908 8.03177 5.00004C8.03177 4.80928 7.87713 4.65465 7.68638 4.65465H5.34537V2.31363Z",
    fill: "#828282"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_542_123975"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg100Clock);
export default __webpack_public_path__ + "static/media/100-clock.6435899872a6b7ef70fd3738d3bbacb1.svg";
export { ForwardRef as ReactComponent };